"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisaIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.VisaIcon = (0, react_1.forwardRef)(function VisaIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "36", height: "24", viewBox: "0 0 36 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.2639 10.0023C17.2769 8.22434 18.8867 6.98242 21.1737 6.98242C22.0655 6.98242 22.7814 7.18095 23.3386 7.38741L22.932 9.3248C21.8964 8.83782 20.982 8.87202 20.6507 8.91585C19.982 9.00532 19.6767 9.35368 19.6693 9.68121C19.6468 10.7586 22.9213 10.8916 22.9111 13.3027C22.9034 15.2027 21.3137 16.4289 18.8826 16.4289C17.8478 16.4178 16.8497 16.1968 16.3095 15.9435L16.7284 13.9413C17.2665 14.1975 17.9417 14.537 19.1048 14.5184C19.7709 14.5079 20.4832 14.2377 20.49 13.6244C20.4935 13.2241 20.1911 12.9367 19.29 12.4891C18.4128 12.0516 17.2488 11.3184 17.2639 10.0023ZM27.248 7.14947H29.2229L31.091 16.2859H28.9509L28.6713 14.9209H25.7029L25.2202 16.2859H22.7907L26.263 7.81958C26.4291 7.41323 26.8036 7.14947 27.248 7.14947ZM27.587 9.61813L26.3689 13.0486H28.2881L27.587 9.61813ZM14.3201 7.14947H16.6335L14.7199 16.2859H12.4059L14.3201 7.14947ZM10.8965 7.14947H13.3268L9.57784 16.2859H7.13209L5.28708 8.99445C5.17509 8.54563 5.07808 8.38085 4.73746 8.19195C4.18118 7.88345 3.26267 7.59398 2.45459 7.41436L2.50914 7.14947H6.44664C6.94814 7.14947 7.39975 7.49047 7.51384 8.08074L8.48802 13.3679L10.8965 7.14947Z", fill: "#223084" })));
});
